@if (isFeatureAvailable) {
<ng-content />
} @if (!isFeatureAvailable) {

<div (click)="facade.showFeatureInfo(mode, feature)">
  @if (customTpl) {
  <ng-template [ngTemplateOutlet]="customTpl" />
  } @else {

  <rt-button variant="outline">
    <rt-icon name="add" />
    <div layout-horizontal layout-align-items-center>
      {{ defaultBtnText() }}
      <rt-icon name="upgrade" size="small-x" [colorToken]="colorToken" margin-left-small-x />
    </div>
  </rt-button>

  }
</div>

}
